// extracted by mini-css-extract-plugin
export default {"rejectedFooter":"RejectedFooter_rejectedFooter__xguGP","content":"RejectedFooter_content__EZZaA"};